<template>
  <div class="bb-service-form" v-click-outside="closeForm">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"></loader-fly>
    </transition>
    <template v-if="!defaultVal">
      <h2 class="bb-service-form__header">
        <transition name="fade-form" mode="out-in">
            <span v-if="institution || project">
              {{institution}} {{project}}
            </span>
        </transition>
        <transition name="fade-form" mode="in-out">
          <span v-if="!institution && !project">
            New service
          </span>
        </transition>
      </h2>
    </template>
    <template v-else>
      <h2 class="bb-service-form__header">
        {{defaultVal.name}}
      </h2>
    </template>
    <div class="bb-service-form-item bb-form">
      <label class="bb-form__label">
        Category
      </label>
      <div class="bb-service-form-item__select">
        <v-select label="name"
                  :options="serviceCategoriesList"
                  :clearable="false"
                  :value="categoryName"
                  @input="setCategory"/>
        <span v-if="errors.serviceType" class="bb-service-form-item__input_error">
            {{errors.serviceType}}
          </span>
      </div>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label">
        Institution
      </label>
      <div class="bb-service-form-item__select">
        <v-select label="name"
                  placeholder="Set Institution"
                  :options="serviceInstitutions"
                  :value="institution"
                  @input="setInstitutions"/>
      </div>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label">
        Project Name
      </label>
      <div class="bb-service-form-item__select">
        <v-select label="name"
                  :options="serviceProject"
                  :clearable="false"
                  :value="project"
                  @input="setProject"/>
        <span v-if="errors.project" class="bb-service-form-item__input_error">
            {{errors.project}}
          </span>
      </div>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label bb-form__label_no-capitalize">
        Type of renewal<br/>(if applies)
      </label>
      <div class="bb-service-form-item__select">
        <v-select label="name"
                  :options="expireCategories"
                  :clearable="true"
                  @input="setExpire"
                  :value="newService.expireCategory || ''"/>
      </div>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label">
        FEE (AED)
      </label>
      <template v-if="!defaultVal">
        <input class="bb-service-form-item__input bb-input bb-input_border"
               type="text" v-model="newService.value"
               v-autofocus
               :class="{'bb-service-form-item__input_failed' : errors.value}"
               @keyup.enter="!defaultVal ? createService() : editService()"
               @keyup.esc="closeForm()">
      </template>
      <template v-else>
        <input class="bb-service-form-item__input bb-input bb-input_border"
               type="text"
               v-model="newService.value"
               v-autofocus
               :class="{'bb-service-form-item__input_failed' : errors.value}"
               @keyup.enter="!defaultVal ? createService() : editService()"
               @keyup.esc="closeForm()">
      </template>
      <span v-if="errors.value" class="bb-service-form-item__input_error">
          {{errors.value}}
        </span>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label">
        VAT (%)
      </label>
      <div class="bb-service-form-item__select">
        <v-select label="name"
                  :options="vatList"
                  :clearable="false"
                  @input="setVAT"
                  :value="newService.vat"/>
      </div>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label bb-form__label_top">
        Notes
      </label>
      <textarea class="bb-service-form-item__textarea"
                v-model="newService.notes"
                @keyup.enter="!defaultVal ? createService() : editService()"
                @keyup.esc="closeForm()">
        </textarea>
    </div>
    <div class="bb-service-form-item">
      <label class="bb-form__label bb-form__label_top">
        Exclude from price list
      </label>
      <checkbox class="bb-service-form-item__checkbox"
                :name="newService"
                @checkboxChange="checkboxChange"
                :value="newService.excludeFromPrice"/>
    </div>
    <template v-if="!defaultVal">
      <button class="bb-service-form__btn-save bb-button"
              @click="createService()">
        ADD
      </button>
    </template>
    <template v-else>
      <button class="bb-service-form__btn-save bb-button"
              @click="editService()">
        SAVE
      </button>
    </template>
  </div>
</template>

<script>
import CustomSelect from '@/components/Main/Inputs/CustomSelect'
import ServicesApi from '@/api/Services/api'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'
import _ from 'lodash'
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Checkbox from '@/components/Main/Inputs/checkbox'
import {expireCategoriesForServiceForm} from '@/constants/expireCategories'
import serviceCategoriesList from '@/mixin/serviceCategoriesList'

export default {
  name: 'ServiceForm',
  props: ['vat', 'defaultVal', 'tab'],
  components: {
    Checkbox,
    CustomSelect,
    LoaderFly,
    vSelect,
    VuePerfectScrollbar
  },
  mixins: [serviceCategoriesList],
  data: function () {
    return {
      errors: {
        serviceType: '',
        project: '',
        value: ''
      },
      oldVat: {
        id: this.defaultVal ? this.defaultVal.vat : false,
        name: this.defaultVal ? this.defaultVal.vat : false
      },
      vatList: [
        {
          id: 0,
          name: '0'
        },
        {
          id: this.vat,
          name: this.vat
        },
        {
          id: 'N/A',
          name: 'N/A'
        }
      ],
      newService: {
        name: [],
        excludeFromPrice: false,
        vat: this.vat,
        expireCategory: ''
      },
      institution: '',
      project: '',
      categoryName: '',
      loaderRun: false,
      expireCategories: expireCategoriesForServiceForm
    }
  },
  computed: {
    serviceCategories: function () {
      return _.orderBy(this.$store.getters.serviceCategories, [item => item.name.toLowerCase()], ['asc'])
    },
    serviceInstitutions: function () {
      return _.orderBy(this.$store.getters.serviceInstitutions, [item => item.name.toLowerCase()], ['asc'])
    },
    serviceProject: function () {
      return _.orderBy(this.$store.getters.serviceProject, [item => item.name.toLowerCase()], ['asc'])
    },
    servicesList: {
      get: function () {
        return this.$store.getters.servicesList
      },
      set: function (data) {
        this.$store.dispatch('setServicesList', data)
      }
    }
  },
  methods: {
    checkboxChange (data) {
      this.newService.excludeFromPrice = data
    },
    createService () {
      if (this.validateForm()) {
        return
      }
      if (Array.isArray(this.newService.name)) {
        this.newService.name = this.newService.name.join(' ')
      }
      this.newService.value = this.newService.value.replace(/,/, '')
      this.setExpireCategory()
      this.loaderRun = true
      ServicesApi.createService(this.newService)
        .then((resp) => {
          const serviceTab = resp.data.excludeFromPrice + 1
          if (this.tab === serviceTab) {
            this.servicesList.unshift(resp.data)
            this.setName(0, this.categoryName, 'category')
            this.setName(0, this.institution, 'institution')
            this.setName(0, this.project, 'project')
          }
          this.loaderRun = false
          this.closeForm()
        })
        .catch((err) => {
          this.loaderRun = false
          console.error(err)
        })
    },
    editService () {
      if (this.validateForm()) {
        return
      }
      if (Array.isArray(this.newService.name)) {
        this.newService.name = this.newService.name.join(' ')
      }
      const index = this.defaultVal.index
      this.setExpireCategory()
      ServicesApi.editService(this.newService)
        .then((resp) => {
          this.closeForm()
          const serviceTab = resp.data.excludeFromPrice + 1
          if (this.tab === serviceTab) {
            this.servicesList.splice(index, 1, resp.data)
            this.setName(index, this.categoryName, 'category')
            this.setName(index, this.institution, 'institution')
            this.setName(index, this.project, 'project')
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setName (index, name, section) {
      this.servicesList[index][section] = {
        id: this.servicesList[index][section],
        name: name
      }
    },
    validateForm () {
      let haveError = false
      if (typeof this.newService.serviceType !== 'number') {
        this.errors.serviceType = 'mandatory field'
        haveError = true
      } else {
        this.errors.serviceType = ''
      }
      if (!this.newService.project) {
        this.errors.project = 'mandatory field'
        haveError = true
      } else {
        this.errors.project = ''
      }
      if (!this.newService.value) {
        this.errors.value = 'mandatory field'
        haveError = true
      } else if (typeof this.newService.value === 'string') {
        this.newService.value = this.newService.value.replace(/,/, '')
      }
      if (isNaN(this.newService.value)) {
        this.errors.value = 'is field must be a number'
        haveError = true
      } else {
        this.errors.value = ''
      }
      return haveError
    },
    closeForm () {
      this.$emit('close')
    },
    getCategory (item) {
      const service = _.find(this.serviceCategoriesList, {id: item})
      return service
    },
    setCategory (item) {
      this.newService.serviceType = item.id
      this.categoryName = item.name
    },
    setInstitutions (item) {
      if (!item) {
        this.newService.name[0] = ''
        this.institution = ''
        this.$delete(this.newService, 'institution')
        return
      }
      this.newService.name[0] = item.name
      this.newService.institution = item.id
      this.institution = item.name
    },
    setProject (item) {
      if (!item) return
      this.newService.name[1] = item.name
      this.newService.project = item.id
      this.project = item.name
    },
    setVAT (item) {
      this.newService.vat = item.name
    },
    setExpire (item) {
      item ? this.newService.expireCategory = item : this.newService.expireCategory = ''
    },
    setExpireCategory () {
      const expireId = _.get(this.newService, 'expireCategory.id', '')
      expireId ? this.newService.expireCategory = expireId : this.newService.expireCategory = 0
    }
  },
  beforeMount () {
    if (this.defaultVal) {
      const institution = _.get(this.defaultVal, 'institution', false)
      if (typeof institution === 'object' && !institution.id) delete this.defaultVal.institution
      this.newService.value = this.defaultVal.value
      this.newService.notes = this.defaultVal.notes || ''
      this.newService.id = this.defaultVal.id
      this.newService.excludeFromPrice = this.defaultVal.excludeFromPrice
      this.newService.expireCategory = _.find(this.expireCategories, {id: this.defaultVal.expireCategory})
    }
    const category = this.defaultVal ? this.getCategory(this.defaultVal.serviceType) : this.serviceCategoriesList[0]
    this.setCategory(category)
    const institution = this.defaultVal ? this.defaultVal.institution : ''
    this.setInstitutions(institution)
    const project = this.defaultVal ? this.defaultVal.project : this.serviceProject[0]
    this.setProject(project)
    const vat = this.defaultVal ? this.oldVat : this.vatList[1]
    this.setVAT(vat)
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";
  @import "../../../../sass/transition";

  .bb-service {
    @include global-font;

    &-form {
      position: relative;
      width: 448px;
      background: $color-white;
      border-radius: 8px;

      &__close {
        position: absolute;
        top: 13px;
        right: 13px;
        color: $color-silver;
        cursor: pointer;
        transition: .15ms;
      }

      &__header {
        color: $color-accent;
        font-size: 18px;
        line-height: 21px;
        text-align: center;
        margin-bottom: 37px;
        font-weight: 500;
      }

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 19px;

        &__select {
          display: flex;
          align-items: center;
          font-size: 12px;
          font-weight: 300;
          width: 366px;
          height: 30px;
        }

        &__input {
          font-family: $global-font;
          width: 366px;
          height: 30px;
          font-size: 12px;

          &_failed {
            border: 1px solid $color-red-orange;
          }

          &_error {
            position: absolute;
            right: 10px;
            color: $color-red-orange;
            font-size: 11px;
            line-height: 13px;
          }
        }

        &__textarea {
          font-family: $global-font;
          width: 366px;
          height: 70px;
          font-size: 12px;
          padding: 8px 10px 8px 15px;
          resize: none;
          border: 1px solid $color-wild-sand;
          box-sizing: border-box;
          border-radius: 5px;
        }

        &__checkbox {
          margin-right: auto;
        }
      }

      &__btn-save {;
        margin: 40px auto 0 auto;
        width: 117px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Services/ServiceForm/ServiceForm.vue